"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    teachingPopoverBodyClassNames: function() {
        return teachingPopoverBodyClassNames;
    },
    useMediaStyles: function() {
        return useMediaStyles;
    },
    useTeachingPopoverBodyStyles_unstable: function() {
        return useTeachingPopoverBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const teachingPopoverBodyClassNames = {
    root: 'fui-TeachingPopoverBody',
    media: 'fui-TeachingPopoverBody__media'
};
const popoverBodyDimension = 288;
const useMediaStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Bw0ie65: 0,
        Br312pm: 0,
        nk6f5a: 0,
        Ijaq50: 0,
        Bq1tomu: "fujjg13",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        a9b677: "f1dxqujg",
        jrapky: "f1jlhsmd",
        ha4doy: "fmrv4ls",
        Brf1p80: "f4d9j23",
        mc9l5x: "f22iagw"
    },
    short: {
        Bubjx69: "f1taewuw",
        Bmuttt3: "fs5pxn9"
    },
    medium: {
        Bubjx69: "f7da563",
        Bmuttt3: "f98prui"
    },
    tall: {
        Bubjx69: "f9ikmtg",
        Bmuttt3: "fqws08j"
    }
}, {
    d: [
        [
            ".fujjg13{grid-area:media;}",
            {
                p: -1
            }
        ],
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        ".f1dxqujg{width:288px;}",
        ".f1jlhsmd{margin-bottom:12px;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".f4d9j23{justify-content:center;}",
        ".f22iagw{display:flex;}",
        ".f1taewuw{aspect-ratio:2.4615384615384617;}",
        ".f7da563{aspect-ratio:1.6363636363636365;}",
        ".f9ikmtg{aspect-ratio:1;}"
    ],
    t: [
        "@supports not (aspect-ratio){.fs5pxn9{height:117px;}}",
        "@supports not (aspect-ratio){.f98prui{height:176px;}}",
        "@supports not (aspect-ratio){.fqws08j{height:288px;}}"
    ]
});
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        Byoj8tv: "fpe6lb7"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".fpe6lb7{padding-bottom:12px;}"
    ]
});
const useTeachingPopoverBodyStyles_unstable = (state)=>{
    'use no memo';
    const { mediaLength } = state;
    const styles = useStyles();
    const mediaStyles = useMediaStyles();
    state.root.className = (0, _react.mergeClasses)(teachingPopoverBodyClassNames.root, styles.root, state.root.className);
    if (state.media) {
        state.media.className = (0, _react.mergeClasses)(teachingPopoverBodyClassNames.media, mediaStyles.base, mediaStyles[mediaLength], state.media.className);
    }
    return state;
}; //# sourceMappingURL=useTeachingPopoverBodyStyles.styles.js.map
